import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductFilterCategories } from 'src/constants/productFilterCategories';
import { externalFilter } from './externalFilter';

import { DropDownCategories } from 'src/types/generic';
import { useContextSelector } from 'use-context-selector';

import { ViewCatalogProductsContext } from './ViewCatalogProductsContext';

const ExternalProductFilterDropdown = () => {
  const { t } = useTranslation();
  const handleConfirm = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.handleConfirm
  );
  const setDataState = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setDataState
  );
  const externalProductFilter = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.externalProductFilter
  );
  const setExternalProductFilter = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setExternalProductFilter
  );
  const setSelectedProduct = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setSelectedProduct
  );
  const setIsProductPanelOpen = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setIsProductPanelOpen
  );
  const setProductSelections = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setProductSelections
  );

  const handleExternalCatalogFilterChange = useCallback(
    async (e: DropDownListChangeEvent) => {
      const value = e.value as DropDownCategories;

      await handleConfirm(() => {
        setExternalProductFilter(value);
        setSelectedProduct(null);
        setIsProductPanelOpen(false);
        setProductSelections({});
        setDataState((prev) => ({
          ...prev,
          skip: 0,
          filter: {
            logic: 'and',
            filters:
              value.value === 0 ? [] : (externalFilter[value.value]?.filters ?? []),
          },
        }));
      });
    },
    [
      handleConfirm,
      setExternalProductFilter,
      setSelectedProduct,
      setIsProductPanelOpen,
      setProductSelections,
      setDataState,
    ]
  );

  const translatedFilterCategories = useMemo(
    () => ProductFilterCategories.map((cat) => ({ ...cat, label: t(cat.label) })),
    [t]
  );

  const translatedValue = useMemo(
    () =>
      externalProductFilter
        ? { ...externalProductFilter, label: t(externalProductFilter.label) }
        : null,
    [externalProductFilter, t]
  );

  return (
    <>
      <DropDownList
        id="catalog-category-dropdown"
        className="k-picker-solid"
        style={{ width: 200 }}
        data={translatedFilterCategories}
        textField="label"
        dataItemKey="value"
        value={translatedValue}
        onChange={handleExternalCatalogFilterChange}
      />
    </>
  );
};

export default ExternalProductFilterDropdown;
